import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosAcusereciboItem', {
    template: template,
    controller: NominasNominaDocumentosAcusereciboItemComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
    require: {
      acuserecibo: '^nominasNominaDocumentosAcuserecibo',
    },
  })

function NominasNominaDocumentosAcusereciboItemComponent(NominasNominaDocumentosAcuserecibo) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.descargar = descargar
  $ctrl.eliminar = eliminar

  function $onInit() {
    $ctrl.idEmpresa = $ctrl.acuserecibo.idEmpresa
    $ctrl.idNomina = $ctrl.acuserecibo.idNomina
    $ctrl.confirmaEliminar = false
    $ctrl.descargando = false
    $ctrl.eliminando = false
  }

  function descargar() {
    return NominasNominaDocumentosAcuserecibo.get($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.data.name)
  }

  function eliminar() {
    if ($ctrl.eliminando)
      return

    $ctrl.eliminando = true

    return NominasNominaDocumentosAcuserecibo.delete($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function () {
        $ctrl.data = null
        $ctrl.confirmaEliminar = false
        $ctrl.onChange({$event: {data: $ctrl.data}})
      }).finally(function () {
        $ctrl.eliminando = false
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/acuserecibo/item/componet.js